import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const PageNumberingView = lazy(() => import("@/features/page-numbering/view"));

export const Route = createFileRoute("/page-numbering")({
  head: () =>
    pageMeta({
      title: "Add page numbers to a PDF",
      description: "Number every page. Pick the position, font, size, and starting number.",
      path: "/page-numbering",
      keywords: "page numbers pdf, number pdf pages, paginate pdf, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <PageNumberingView />
    </Suspense>
  ),
});
